module.exports = __webpack_public_path__ + "img/spazi_2.ab185ddf.webp";